import type { TTaskSlaPulseLevel } from '../../types.ts';
import {
  MILLISECONDS_IN_SECOND,
  SECONDS_IN_HOUR,
  SECONDS_IN_MINUTE,
  TASK_SLA_PULSE_LEVELS,
} from './constants.ts';

export const padTimePart = (value: number): string => String(value).padStart(2, '0');

export const formatTaskSlaDeadline = (deadline: string): string => {
  const date = new Date(deadline);

  if (!Number.isFinite(date.getTime())) {
    return '';
  }

  const day = padTimePart(date.getDate());
  const month = padTimePart(date.getMonth() + 1);
  const year = date.getFullYear();
  const hours = padTimePart(date.getHours());
  const minutes = padTimePart(date.getMinutes());

  return `${day}.${month}.${year} ${hours}:${minutes}`;
};

export const getTaskSlaRemainingSeconds = (deadline: string, now = Date.now()): number => {
  const deadlineTime = new Date(deadline).getTime();

  if (!Number.isFinite(deadlineTime)) {
    return 0;
  }

  return Math.max(0, Math.ceil((deadlineTime - now) / MILLISECONDS_IN_SECOND));
};

export const formatTaskSlaCountdown = (remainingSeconds: number): string => {
  const normalizedSeconds = Math.max(0, remainingSeconds);
  const hours = Math.floor(normalizedSeconds / SECONDS_IN_HOUR);
  const minutes = Math.floor((normalizedSeconds % SECONDS_IN_HOUR) / SECONDS_IN_MINUTE);
  const seconds = normalizedSeconds % SECONDS_IN_MINUTE;

  return hours > 0
    ? `${padTimePart(hours)}:${padTimePart(minutes)}:${padTimePart(seconds)}`
    : `${padTimePart(minutes)}:${padTimePart(seconds)}`;
};

export const getTaskSlaPulseLevel = (
  remainingSeconds: number,
  isOverdue: boolean
): TTaskSlaPulseLevel => {
  if (isOverdue) {
    return 'overdue';
  }

  return (
    TASK_SLA_PULSE_LEVELS.find(({ threshold }) => remainingSeconds <= threshold)?.level ?? 'calm'
  );
};
